export function throttle(callee: any, timeout: number) {
  let timer: NodeJS.Timeout | undefined = undefined;

  return function perform(args: any) {

    if (timer) return;

    timer = setTimeout(() => {
      callee(args);
      clearTimeout(timer);
      timer = undefined;
    }, timeout);
  };
}
